import {Component, ElementRef, ViewChild} from '@angular/core';
import {ModalController, NavController, NavParams} from 'ionic-angular';


import {LicitacaoService} from '../../../../providers/licitacao-service';
import {AlertService} from '../../../../providers/alert-service';
import {MenuService} from '../../../../providers/menu-service';
import {ModulosController} from '../../modulos-controller';
import {UsuarioService} from '../../../../providers/usuario-service';
import {GestaoPcaService} from '../../../../providers/gestao-pca-service';

@Component({
    selector: 'page-bens-servicos-convite-tomada-concorrencia',
    templateUrl: 'bens-servicos-convite-tomada-concorrencia.html',
    providers: [
        LicitacaoService
    ]
})

export class BensServicosConviteTomadaConcorrenciaPage extends ModulosController {
    @ViewChild('myInput') myInput: ElementRef;

    listaDados: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "64";

    page: number = 1;

    order: string = 'numeroContrato';
    reverse: boolean = true;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public licitacaoService: LicitacaoService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        this.setModuloId(7);
    }

    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = false;
            this.order = "-" + value;
        } else {
            this.reverse = true;
            this.order = value;
        }
    }

    carregarDados() {
        this.licitacaoService.obterAquisicaoDeBensEServicos().subscribe(data => {
            this.listaDados = data;

            // data.forEach(element => {
            //     if (this.listaDados)
            // });

            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaLicitacao() {
        this.menuService.redirecionarPagina(this.licitacaoService.obterIdPaginaLicitacao());
    }

    salvarFlagIncluir(enviarMensagem = true) {
        this.loading = true;
        this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
        this.licitacaoService.salvarAnalisesLicitacao(this.listaDados, this.idSecaoPagina).subscribe(data => {
            if (enviarMensagem) {
                this.alertService.mostraAlerta("", "Salvo com sucesso.");
                this.loading = false;
            }
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
            this.loading = false;
        })
    }

    submeterNoCertificado() {
        this.loading = true;
        if (this.listaDados.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resultadoAnalise == null || this.listaDados.resultadoAnalise == undefined || !this.listaDados.resultadoAnalise) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
                this.licitacaoService.finalizarAnalisesLicitacao(this.listaDados, this.idSecaoPagina).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaLicitacao();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    formatarZeroEsquerda(valor) {
        return valor.replace(/^0+(?!\.|$)/, '');
    }

    capitalize(str) {
        let retorno = "";
    
        if (str) {
          retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }
    
        return retorno;
      }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/licitacao/bens-servicos-convite-tomada-concorrencia/bens-servicos-convite-tomada-concorrencia.ts